import appConfig from 'configs/app.config'
import ApiService from './ApiService'
import {
    endpoints,
    REQUEST_HEADER_AUTH_KEY,
    TOKEN_TYPE,
} from 'constants/api.constant'
import axios from 'axios'
import store from '../store'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import { setUser } from 'store/auth/userSlice'
import { Notification, toast } from 'components/ui'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: appConfig.baseUrl + '/admin/api/auth/login',
        method: 'post',
        data,
    })
}
export const apiRefreshToken = async () => {
    try {
        const { auth } = store.getState()
        const refreshToken = auth.session.refreshToken

        const headers = {}
        headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${refreshToken}`
        console.log('headers', headers)
        // Make an API request to refresh the token
        const response = await axios.post(
            appConfig.baseUrl + endpoints.REFRESH_TOKEN,
            null,
            { headers }
        )

        const newAccessToken = response.data.access_token
        // Update the token in your application state
        store.dispatch(onSignInSuccess(newAccessToken))
        store.dispatch(setUser(response.data.user))

        return newAccessToken
    } catch (error) {
        console.log('refreshtoken', error)
        store.dispatch(onSignOutSuccess())
        setTimeout(() => {
            toast.push(
                <Notification closable type="danger" duration={3000}>
                    {error.response.data.message || error.message}
                </Notification>
            )
        }, 1)
        throw error
    }
}
export async function apiStoreFirebaseToken(data) {
    return ApiService.fetchData({
        url: appConfig.baseUrl + '/admin/api/auth/set-firebase-token',
        method: 'post',
        data,
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data,
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data,
    })
}
export async function apiChangePassword(data) {
    console.log('pass', data)
    return ApiService.fetchData({
        url: appConfig.baseUrl + '/admin/api/auth/change-password',
        method: 'post',
        data,
    })
}
